import React from "react"
import { Link } from "gatsby"

export default function Menu() {
  return (
    <nav>
      <ul>
        <li>
          <Link activeClassName="currentPage" to={`/blog`}>
            Blog
          </Link>
        </li>

        <li>
          <Link activeClassName="currentPage" to={`/projects`}>
            Projects
          </Link>
        </li>

        <li>
          <Link activeClassName="currentPage" to={`/contact`}>
            Contact
          </Link>
        </li>
        <li className="menuDivider">Tools</li>
        <li>
          <Link activeClassName="currentPage" to={`/ip`}>
            IP
          </Link>
        </li>
        <li>
          <Link activeClassName="currentPage" to={`/type7`}>
            Type7
          </Link>
        </li>
        </ul>
        <ul>
        <li className="menuDivider">Links</li>
        <li>
          <a href="https://twitter.com/mdxkln" target="_blank" rel="noopener">
            Twitter  <img src="/images/social/twitter.svg" style={{width:"20px"}}/>
          </a>
        </li>
        <li>
          <a href="https://github.com/mdjx" target="_blank" rel="noopener">
            GitHub <img src="/images/social/github.svg" style={{width:"20px"}}/>
          </a>
        </li>{/*
        <li>
          <a href="https://www.linkedin.com/in/milosh-djuric/" target="_blank" rel="noopener">
            LinkedIn
          </a>
        </li>*/}
      </ul>
    </nav>
  )
}
